import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const code = sessionStorage.getItem("admin_code");
  if (code) {
    config.headers.Authorization = `Bearer ${code}`;
  }
  return config;
});

export const isAdminLoggedIn = () => Boolean(sessionStorage.getItem("admin_code"));
export const adminLogout = () => sessionStorage.removeItem("admin_code");

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  return err?.message || "Something went wrong";
}
